import React, { Component } from 'react';
import ReactTable from 'react-table';
import {
	Card,
	CardBody,
	Button,
	Form,
	Input,
} from 'reactstrap';
import {I18n} from '../../I18n/components/memberList';
import profilephoto from '../../assets/images/users/1.jpg';

import 'react-table/react-table.css';
import './membersList.css';

import { MEMBERSMODALVIEWS } from '../../helpers/constants';
import {GET_FILTERED_PACKAGES} from "../../actions/retailActions";
import Pagination from '../Pagination/Pagination';
import {connect} from "react-redux";
import {deleteSingleStore, fetchStores, filteringStores, saveNewStore, updateSingleStore} from "../../actions/storesActions";
import {fetchCompanies} from "../../actions/companyActions";
import {fetchUsers} from "../../actions/usersActions";

class MembersList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			members: [],
			filteredMembers: []
		}
	}

	componentDidMount() {
		const members = this.props.view === MEMBERSMODALVIEWS.REMOVE ?
			this.props.members : this.props.companyUsers;
		this.setState({
			members: members,
			filteredMembers: members
		})
	}

	componentDidUpdate(prevProps) {
		if (this.props.members !== prevProps.members) {
			const members = this.props.view === MEMBERSMODALVIEWS.REMOVE ?
				this.props.members : this.props.companyUsers;
			this.setState({
				members: members,
				filteredMembers: members
			})
		}
	}

	onFilterClick = event => {
		const filterWord = event.target.value;
		let filtered = [];
		if (filterWord) {
			filtered = this.state.members.filter( item =>
				item.name.toLowerCase().indexOf(filterWord.toLowerCase()) != -1);
		} else {
			filtered = this.state.members;
		}
		this.setState({
			filteredMembers: filtered
		})
	};

	render() {
		const {lang} = this.props;
		const { filteredMembers, members } = this.state;
		return (
			<Card className='memberlist '>
				<CardBody>
					<div className="memberlist-card">
						<Form className="memberlist-searchform">
							<Input
								type="text"
								name="memberlistSearch"
								id="memberlistSearch"
								onChange={this.onFilterClick}
								placeholder={I18n[lang].searchPlaceholder}
							/>
						</Form>
					</div>
					{
						(() => {
							let userEmails = null;
							if (this.props.view === MEMBERSMODALVIEWS.ADD) {
								 userEmails = this.props.members.map(item => {
									return item.email;
								});
							}
							let firstElementNumber = 0;
							const tableData = filteredMembers.map((member, index) => {
								return {
									//count_id: firstElementNumber++,
									id: member.id,
									name: member.name,
									email: member.email,
									actions: (
										<div className="text-center ">
											{
												this.props.view === 'remove' ? (
													<Button
														title="delete"
														onClick={() => {this.props.removeMembers(member)}}
														className="ml-1 storeslist-card__btn"
														color="danger"
														size="sm"
														round="true"
														icon="true"
													>
														<i className="fa fa-times"/>
													</Button>
												) : !userEmails.includes(member.email) ? (
														<Button
															title="add"
															className="storeslist-card__btn"
															onClick={() => {
																let selectedMember = tableData.find(item => item.id === member.id);
																this.props.addMembers(selectedMember);
															}}
															color="primary"
															size="sm"
															round="true"
															icon="true"
														>
															<i className="fas fa-user-plus"/>
														</Button>
													) : (
														<i className="fas fa-check icon__added" />
													)
											}
										</div>
									),
									memberData: member
								};
							});
							return (
								<div className="members-table">
									<ReactTable
										getProps={(state, rowInfo, column, instance) => {
											return {
												style: {
													border: "none",
													padding: "5px"
												}
											};
										}}
										getTheadProps={(state, rowInfo, column, instance) => {
											return {
												style: {
													boxShadow: "none",
													padding: "10px 0",
													fontWeight: "600"
												}
											};
										}}
										getTheadThProps={(state, rowInfo, column, instance) => {
											return {
												style: {
													borderRight: "none"
												}
											};
										}}
										getTdProps={(state, rowInfo, column, instance) => {
											return {
												style: {
													borderRight: "none",
													textAlign: "center"
												}
											};
										}}
										getTrProps={(state, rowInfo, column, instance) => {
											return {
												style: {
													alignItems: "center"
												}
											};
										}}
										getNoDataProps={(state, rowInfo, column, instance) => {
											return {
												style: {
													top: "100%"
												}
											};
										}}
										columns={[
											{
												Header: "#",
												accessor: "count_id",
												sortable: false,
												filterable: false,
												style: {
													textAlign: "left",
													fontSize: "0.7rem",
													textTransform: "lowercase"
												},
												maxWidth: 40,
												Cell: (row) => {
													return <div>{row.index + 1}</div>;
												}

											},
											{
												Header: `${I18n[lang].member}`,
												accessor: "name",
												sortable: false,
												filterable: false,
												minWidth: 200,
												style: {
													fontSize: "1.2rem",
													textAlign: "left"
												},
												Cell: row => (
													<div className="stores-table__img">
														<img
															src={row.value && row.value.img ? row.value.img : profilephoto}
															alt="user"
															className="rounded-circle"
															width="60"
														/>
														<span>{row.value}</span>
													</div>
												)
											},
											{
												Header: `${I18n[lang].contacts}`,
												accessor: "email",
												sortable: false,
												filterable: false,
												maxWidth: 100,
												style: {
													fontSize: "0.7rem",
													textTransform: "lowercase",
												},
												Cell: row => (
													<span>{row.value}</span>
												)
											},
											{
												Header: "",
												accessor: "actions",
												sortable: false,
												filterable: false,
												maxWidth: 150
											}
										]}
										// defaultPageSize={-1}
										// pageSize={tableData.length}
										// showPaginationBottom={false}
										// className="-highlight"
										// data={tableData}
										// filterable
										PaginationComponent={Pagination}
										nextText={">>"}
										previousText={"<<"}
										pageSize={10}
										minRows={0}
										defaultPageSize={-1}
										showPaginationBottom={tableData.length  && tableData.length > 10 ? true : false}
										className="-highlight"
										data={tableData}
										filterable

									/>
								</div>
							)
						})()
					}
				</CardBody>
			</Card>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
	};
};

const mapStateToProps = state => ({
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(MembersList)





// WEBPACK FOOTER //
// ./src/components/MemberList/MembersList.js